module.exports = __webpack_public_path__ + "static/banner-02bfc5ff3f16cd994f46c411fc1235ff.jpg";